import { useEffect, useState, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb, { getCategoryLabel } from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'sousuo-jiqiao');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
      window.scrollTo(0, 0);
    }
  }, [slug]);

  const filteredArticles = useMemo(
    () => articles.filter((a) => a.category === activeSlug),
    [activeSlug]
  );

  const activeCategory = categories.find((c) => c.slug === activeSlug);

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-10">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              {activeCategory?.name || '分类'}
            </h1>
            <p className="text-sm text-foreground-600 max-w-xl">
              {activeCategory?.description || '浏览该分类下的所有教程文章'}
            </p>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: activeCategory?.name || '分类' },
            ]}
          />

          <div className="flex flex-wrap gap-2 mb-8 overflow-x-auto pb-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="space-y-4 pb-14">
            {filteredArticles.length > 0 ? (
              filteredArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} variant="default" />
              ))
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}